import { useState } from "react";
import { Reveal } from "./Reveal";
import { useLang } from "@/lib/i18n";
import { Heart, Users, Instagram } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const TEAM_URL = "https://forms.gle/EWBCLnDHccnfm9Br8";
const INSTA_URL = "https://www.instagram.com/code.echo_first.aid?utm_source=qr";

export default function JoinMission() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  return (
    <section
      id="join"
      data-testid="join-section"
      className="relative bg-[#0B0C10] pt-0 pb-20 md:pb-28"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal>
          <div
            data-testid="join-card"
            className="relative w-full rounded-3xl border border-white/10 bg-[#12131C] px-6 py-12 md:px-14 md:py-16 text-center"
            style={{ boxShadow: "0 0 80px -10px rgba(255,255,255,0.18), 0 0 24px -6px rgba(255,255,255,0.1)" }}
          >
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold uppercase tracking-tight text-white">
              {t.join_title}
            </h2>
            <div className="mt-12 grid gap-4 sm:grid-cols-3 max-w-3xl mx-auto">
              <button
                data-testid="donate-btn"
                onClick={() => setOpen(true)}
                className="group relative flex w-full items-center justify-center overflow-hidden rounded-sm bg-[#E11B22] px-6 py-4 text-sm font-bold uppercase tracking-[0.18em] text-white transition-all duration-300 hover:glow-red"
              >
                <span className="relative z-10 flex items-center gap-3 justify-center">
                  <Heart className="h-4 w-4" /> {t.join_donate}
                </span>
                <span className="absolute inset-0 -translate-y-full bg-[#b31017] transition-transform duration-300 group-hover:translate-y-0" />
              </button>
              <a
                data-testid="join-team-link"
                href={TEAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative flex w-full items-center justify-center overflow-hidden rounded-sm bg-[#D4AF37] px-6 py-4 text-sm font-bold uppercase tracking-[0.18em] text-[#0B0C10] transition-all duration-300 hover:glow-gold"
              >
                <span className="relative z-10 flex items-center gap-3 justify-center">
                  <Users className="h-4 w-4" /> {t.join_team}
                </span>
                <span className="absolute inset-0 -translate-y-full bg-[#e6c65a] transition-transform duration-300 group-hover:translate-y-0" />
              </a>
              <a
                data-testid="join-insta-link"
                href={INSTA_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative flex w-full items-center justify-center overflow-hidden rounded-sm bg-[#0057B7] px-6 py-4 text-sm font-bold uppercase tracking-[0.18em] text-white transition-all duration-300 hover:glow-blue"
              >
                <span className="relative z-10 flex items-center gap-3 justify-center">
                  <Instagram className="h-4 w-4" /> {t.join_insta}
                </span>
                <span className="absolute inset-0 -translate-y-full bg-[#003f86] transition-transform duration-300 group-hover:translate-y-0" />
              </a>
            </div>
          </div>
        </Reveal>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="border-white/15 bg-[#0d0e14]/95 backdrop-blur-xl text-white sm:rounded-sm"
          data-testid="donate-modal"
        >
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl font-medium">
              {t.join_donate}
            </DialogTitle>
            <DialogDescription className="text-zinc-300 pt-2 text-base leading-relaxed">
              {t.join_donate_msg}
            </DialogDescription>
          </DialogHeader>
          <button
            onClick={() => setOpen(false)}
            data-testid="donate-close"
            className="mt-4 rounded-sm bg-[#E11B22] px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-white hover:opacity-90 transition"
          >
            {t.close}
          </button>
        </DialogContent>
      </Dialog>
    </section>
  );
}
